import { ready } from '../utils';

// Bearer credentials and share codes. cio_link_id and rc are campaign ids; they
// are stripped from the address bar but are not account secrets.
export const BLOCKLISTED_QUERY_PARAMS = [
  'jwt',
  'eu',
  'ali',
  'unlock',
  'pu',
  'freelink_shortcode',
  'cio_link_id',
  'rc', // Remove incoming rc if any; add this user's rc below
];

export const removeBlocklistedParams = () => {
  const urlParams = new URLSearchParams(location.search);
  const affiliateCodeParam =
    typeof currentUser !== 'undefined' && currentUser && currentUser.affiliate_code;
  BLOCKLISTED_QUERY_PARAMS.forEach((param) => urlParams.delete(param));
  if (urlParams.toString() === '') {
    replaceHistoryStateSafely(`${window.location.pathname}${window.location.hash}`);
  } else {
    const newUrl = `${window.location.pathname}?${urlParams}${window.location.hash}`;
    replaceHistoryStateSafely(newUrl);
  }
  // Add this user's rc to the URL, in case they share the page
  if (affiliateCodeParam && window.history.replaceState) {
    urlParams.set('rc', affiliateCodeParam);
    const newUrl = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
    replaceHistoryStateSafely(newUrl);
  }
};

const replaceHistoryStateSafely = (newUrl) => {
  try {
    if (window.location.pathname.includes('//')) {
      return;
    }
    window.history.replaceState({}, document.title, newUrl);
  } catch (e) {
    console.error(`CleanParamsJs with newUrl: ${newUrl}`, e.message);
  }
};

ready(removeBlocklistedParams);
